



























































import { Component, Vue, Watch } from "vue-property-decorator";
import { API_BIS_REPORT_STAT } from "@/configs/Apis";
import Ajax from "@/utils/DuduAjax";
import ReportTable from "@/views/report/ReportTable.vue";
import ReportChart from "@/views/report/ReportChart.vue";

import cloneDeep from "lodash/cloneDeep";

import { MONITOR_PROJECT_ID, MONITOR_REPOPRTS, VALID_PATENT_CONDITION } from "@/app-data/monitor/monitor";
import { RequestConfig } from "@/types";

@Component({
  components: { ReportTable, ReportChart }
})
export default class StatisticsPreview extends Vue {
  queryType = "0";
  requests: { [K: string]: RequestConfig } = {
    basic: {
      api: { url: API_BIS_REPORT_STAT, path: {} },
      loading: false,
      method: "POST",
      callback: this.processChartData.bind(this),
      params: (function () {
        return cloneDeep(MONITOR_REPOPRTS.basicModel.definition);
      })(),
      data: {},
      extra: { model: MONITOR_REPOPRTS.basicModel, chartOption: {} }
    },
    validPatents: {
      api: { url: API_BIS_REPORT_STAT, path: {} },
      loading: false,
      method: "POST",
      callback: this.processChartData.bind(this),
      params: (function () {
        return cloneDeep(MONITOR_REPOPRTS.validPatentModel.definition);
      })(),
      data: {},
      extra: { model: MONITOR_REPOPRTS.validPatentModel, chartOption: {} }
    },
    applicantPatents: {
      api: { url: API_BIS_REPORT_STAT, path: {} },
      loading: false,
      method: "POST",
      callback: this.processChartData.bind(this),
      params: (function () {
        return cloneDeep(MONITOR_REPOPRTS.applicantModel.definition);
      })(),
      data: {},
      extra: { useQueryType: true }
    },
    inventorPatents: {
      api: { url: API_BIS_REPORT_STAT, path: {} },
      loading: false,
      method: "POST",
      callback: this.processChartData.bind(this),
      params: (function () {
        return cloneDeep(MONITOR_REPOPRTS.inventorModel.definition);
      })(),
      data: {},
      extra: { useQueryType: true }
    }
  }

  get projectId() {
    // this.$store.state.project.info.id
    return this.$route.query.id || MONITOR_PROJECT_ID;
  }

  mounted() {
    this.processRequestData();
  }

  processRequestData() {
    this.processRequestDataByRequests(this.requests);
  }

   @Watch("queryType")
  onQueryTypeChange() {
    this.processRequestDataByRequests({
      applicantPatents: this.requests.applicantPatents,
      inventorPatents: this.requests.inventorPatents
    });
  }

   processRequestDataByRequests(requests: { [K: string]: RequestConfig }) {
     Object.keys(requests).forEach(name => {
       (async () => {
         const config = requests[name];
         this.requestOne(config);
       })();
     });
   }

   async requestOne(config: RequestConfig) {
     try {
       if (config.once === true && (config as any).__loaded === true) {
         return;
       }
       config.loading = true;
       let params;
       if (typeof config.params === "function") {
         params = (config.params as (this: Vue) => any).call(this as any);
       } else {
         params = config.params;
       }
       params = cloneDeep(params);
       if (config.extra && config.extra.useQueryType) {
         switch (this.queryType) {
           case "0":
             params.condition = {
               items: [{
                 name: "authDate",
                 operator: "NOT_NULL"
               }]
             };
             break;
           case "1":
             params.condition = {
               items: [{
                 name: "authDate",
                 operator: "BETWEEN",
                 value1: (new Date().getFullYear()) + "-01-01",
                 value2: (new Date().getFullYear()) + "-12-31"
               }]
             };
             break;
           case "2":
             params.condition = {
               items: [{
                 name: "appDate",
                 operator: "NOT_NULL"
               }]
             };
             break;
           case "3":
             params.condition = {
               items: [{
                 name: "appDate",
                 operator: "BETWEEN",
                 value1: (new Date().getFullYear()) + "-01-01",
                 value2: (new Date().getFullYear()) + "-12-31"
               }]
             };
             break;
           case "4":
             params.condition = {
               items: [VALID_PATENT_CONDITION]
             };
             break;
           default:
         }
       }

       if (!Object.prototype.hasOwnProperty.call(config.api.path, "projectId")) {
         config.api.path.projectId = this.projectId;
       }
       const res = await Ajax.queryData(config.api, params, config.method, false, false);
       if (config.callback && typeof config.callback === "function") {
         config.callback.call(this, res, config);
       }
     } finally {
       config.loading = false;
       if (config.once === true) {
         (config as any).__loaded = true;
       }
     }
   }

   processChartData(data: any, config: RequestConfig) {
     config.data = data;
     const model = config.extra?.model;
     if (model) {
       config.extra.chartOption = model.chart(config.params, model.chartOption, data);
     }
   }
};
